import { RuleOptionType, RuleSuggestionOptionType } from "./Pages/DefineModel/model";

export const ISR_TITLE: string = "Guide";
export const CREATE: string = "Create";
export const PROMOTE_DATA: string = "Promote Data";
export const EMPTY_ISR: string = "You haven't created any model yet";
export const EMPTY_RULES: string = "You haven't created any Relationships yet";
export const CREATE_ISR: string = "Create Model";
export const ISR_NAME: string = "Model Name";
export const ENTER_NAME: string = "Enter Name";

// MainPage Constants
export const CANCEL: string = "Cancel";
export const SAVE_AS_DRAFT: string = "Save as draft";
export const DEFINE_MODEL: string = "Define Model";
export const DEFINE_UI: string = "Define UI";
export const PREVIEW: string = "Preview";

export const ADDITIONAL_DATA: string = "Additional data";
export const DESCRIPTION: string = "Description";
export const HOVER_TEXT: string = "Info (Hover text)";
export const PLACEHOLDER_URL: string = "https://www.example.com";
export const RULES: string = "Rules";
export const RELATIONSHIPS: string = "Relationships";
export const NO_RULES: string = "No Rules";
export const FIELD_DETAILS: string = "Field Details";
export const CONNECTOR_DETAILS: string = "Binding Details";
export const TITLE: string = "Title";
export const DATA_TYPE: string = "Data Type";
export const PROJECT_NAME: string = "Project Name";
export const TEXT: string = "TEXT";
export const DATA_CONFIGURATION: string = "Data Configuration";
export const ENDPOINT: string = "Endpoints";
export const MAX_CHAR_COUNT: string = "Max Character Count";
export const DEFAULT_VALUE: string = "Default Value";
export const REQUIRED: string = "Required";
export const ANALYTIC: string = "Analytics";
export const PREDICTIVE_SORT: string = "Predictive sort";
export const ENTER: string = "Enter";
export const CBM: string = "CBM";
export const ASYMMETRIC: string = "Asymmetric";
export const NAME: string = "Name";
export const DATA_IMPORT: string = "Data Import";
export const CHOICES: string = "Choices";
export const ENTER_CHOICE: string = "Enter choice";
export const COLLAPSE_ALL: string = "Collapse All";
export const EXPAND_ALL: string = "Expand All";
export const ADD_NEW: string = "Add new";
export const SELECTION_TYPE: string = "Selection Type";
export const SELECT_TYPE: string = "Select Type";
export const MIN: string = "Min";
export const MAX: string = "Max";
export const INCREMENT: string = "Increment";
export const DECIMAL_POINTS: string = "Decimal Points";
export const LABEL: string = "Label";
export const ENTER_LABEL: string = "Enter Label";
export const SUB_MODEL_DETAILS: string = "Sub model details";
export const SUB_MODEL_NAME: string = "Sub model name";
export const SUB_MODEL: string = "Sub model";
export const CUSTOM_LABEL: string = "End user can set custom label";
export const MULTIPLE_INSTANTIATION: string = "Multiple Instantiation";
export const COUNT: string = "Count ";
export const QUANTITY: string = "Quantity";
export const CONSUME_ENDPOINT: string = "Consume Endpoint";
export const MIN_INSTANTIATION: string = "Min instances";
export const MAX_INSTANTIATION: string = "Max instances";
export const DECIMAL_CONVERSION: string = "Decimal conversion";
export const UNITS: string = "Units";
export const LABLE_WHOLE_NUMBER: string = "Label Whole Number";
export const LABLE_FRACTION: string = "Label Fraction ";
export const PRODUCT_CATEGORY: string = "Category";
export const MANAGE: string = "Manage";
export const MANAGE_CLASS: string = "Manage Class";
export const MANAGE_RULES: string = "Manage Rules";
export const FIELD_TEXT: string = "Field - Text";
export const MODEL: string = "Model";
export const OPTIMIZATION: string = "Optimization";
export const ANALYTICS: string = "Analytics";
export const UI_MODEL: string = "UI Model";
export const UI_PREVIEW: string = "UI Preview";
export const SERIALIZATION: string = "Serialization";
export const UI_BUILDER: string = "UI Builder";
export const USER_INTERFACE: string = "User Interface";
export const RECOMMENDER: string = "Recommender";
export const DATA_MODEL: string = "Data Model";
export const ALL: string = "All";
export const CREATE_CATEGORY: string = "Create Category";
export const CATEGORY_NAME: string = "Category Name";
export const CONNECTOR_NAME: string = "Binding Name";
export const CREATE_SUB_MODEL: string = "Create Sub Model";
export const CREATE_MODEL_NAME: string = "Sub Model Name";
export const CREATE_FIELD: string = "Create Field"
export const CREATE_CLASS: string = "Create Class"
export const FIELD_NAME: string = "Field Name";
export const CLASS_NAME: string = "Class Name";
export const ASSIGN_COLOR: string = "Assign Color";
export const ASSIGNED_COLOR: string = "Assigned Color";
export const DELETE: string = "Delete";
export const ADD_CATEGORY: string = "Add Category";
export const ADD_ENDPOINT: string = "Add Endpoints";
export const SHOW_FILTER: string = "Show Filter";
export const CATEGORY: string = "Category";
export const SELECT_CATEGORY_TYPE: string = "Select Category Type";
export const SELECT_ALL: string = "Select All";
export const DESELECT_ALL: string = 'Deselect All';
export const MIN_TOOL_TIP: string = `Example: “24-1/2” or“24 1/2”`;
export const FILTERING_RANGE: string = 'Filter range';
export const OPERATOR_MIN: string = 'Operator (Min)';
export const OPERATOR_MAX: string = 'Operator (Max)';
export const MAX_ATTRIBUTE: string = 'Max Attribute';
export const MIN_ATTRIBUTE: string = 'Min Attribute';
export const MODEL_CLASS: string = 'Model Class';
export const FIELD_CLASS: string = "Field Class";
export const CLASS: string = "Class";
export const TYPE: string = "Type";
export const RATING_LEVELS: string = "Rating Levels";
export const INCOMPATIBLE: string = "Incompatible";
export const BEST: string = "Best";
export const DEFAULT_RATING: string = "Defaul Rating";
export const FIELDS: string = "Fields";

// Field Menus
export const MULTI_CHOICE: string = "Multi-choice";
export const TEXT_FIELD: string = "Text";
export const FIELD: string = "Field";
export const INTEGER: string = "Integer";
export const DECIMAL: string = "Decimal";
export const BOOLEAN: string = "Boolean";
export const FRACTION: string = "Fraction";
export const SUB_MODEL_TYPE: string = "Submodel";
export const ATTRIBUTES: string = "Attributes";
export const CONNECTOR: string = "Binding";
export const CREATE_CONNECTOR: string = "Create Binding";
export const CATEGORY_TYPE: string = "Category";
export const CALCULATED: string = "Calculated";
export const FILTER: string = "Filter";
export const RANGE_FIELD: string = "Range";

export const EMPTY_FIELDS: string = "To get started, let's create a sub model, fields or category.";
export const ERROR_MESSAGE: string = 'The class name must be in uppercase, contain only letters and numbers, and cannot begin with a number.';
export const CALCULATED_TOOL_TIP = 'Enable this option to show dynamically calculated value at the runtime based on a specified rule. Once enabled, this field will not be editable as an input.'
export const FILTER_TOOL_TIP = 'Enable to allow use of this field to filter on categories and attributes.'

// UI Definition constants
export const ENABLE_CONDITION: string = "Enable Condition";
export const CLICK_TO_HIDE: string = "Click to hide";
export const CLICK_TO_SHOW: string = "Click to show";

//Rules constant
export const MATH: string = "Math"
export const CONDITIONAL: string = "Conditional"
export const COMPATIBILITY_BY_ATTRIBUTE: string = "Compatibility by attribute"
export const COMPATIBILITY_BY_ITEM: string = "Compatibility by item"
export const COMPATIBILITY_BY_MATRIX: string = "Compatibility by matrix"
export const LOGIC: string = "Logic"
export const CREATE_TRANSFORMATION_FIELD: string  = "Create Transformation Field"
export const TRANSFORMATION: string = "Transformation"
export const TRANSFORMATION_NAME: string = "Transformation Name"
export const CREATE_NEW_CONDITION: string = "Add New Condition"
export const RULE_SUGESSTION_OPTIONS: RuleSuggestionOptionType[] = [
    {
      id: 0,
      label: "Sub model",
      description: "Sub model helps you to group the rule",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 1,
      label: "Field",
      description: "Define fields and values",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 2,
      label: "Category",
      description: "Define products recommendation",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 3,
      label: "Operators",
      description: "== != > < >= <=",
      hasOptions: true,
      child: [
        {
          id: "Operators_0",
          label: "==",
        },
        {
          id: "Operators_1",
          label: "!=",
        },
        {
          id: "Operators_2",
          label: ">",
        },
        {
          id: "Operators_3",
          label: "<",
        },
        {
          id: "Operators_4",
          label: ">=",
        },
        {
          id: "Operators_5",
          label: "<=",
        },
      ],
      type: null,
    },
    {
      id: 4,
      label: "Logical",
      description: "If, Then, And, Or, Not",
      hasOptions: true,
      child: [
        {
          id: "Logical_0",
          label: "If",
        },
        {
          id: "Logical_1",
          label: "Then",
        },
        {
          id: "Logical_2",
          label: "And",
        },
        {
          id: "Logical_3",
          label: "Or",
        },
        {
          id: "Logical_4",
          label: "Not",
        },
      ],
      type: null,
    },
    {
      id: 5,
      label: "Math",
      description: "Define math expressions",
      hasOptions: false,
      child: [],
      type: null,
    },
  ];

  export const TRANFORMATION_RULE_SUGESSTION_OPTIONS: RuleSuggestionOptionType[] = [
    {
      id: 0,
      label: "Sub model",
      description: "Sub model helps you to group the rule",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 1,
      label: "Field",
      description: "Define fields and values",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 2,
      label: "Category",
      description: "Define products recommendation",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 3,
      label: "Attributes",
      description: "Define Attributes",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 4,
      label: "Transformation",
      description: "Define Transformation",
      hasOptions: false,
      child: [],
      type: null,
    },
    {
      id: 5,
      label: "Operators",
      description: "== != > < >= <=",
      hasOptions: true,
      child: [
        {
          id: "Operators_0",
          label: "==",
        },
        {
          id: "Operators_1",
          label: "!=",
        },
        {
          id: "Operators_2",
          label: ">",
        },
        {
          id: "Operators_3",
          label: "<",
        },
        {
          id: "Operators_4",
          label: ">=",
        },
        {
          id: "Operators_5",
          label: "<=",
        },
      ],
      type: null,
    },
    {
      id: 6,
      label: "Logical",
      description: "If, Then, And, Or, Not",
      hasOptions: true,
      child: [
        {
          id: "Logical_0",
          label: "If",
        },
        {
          id: "Logical_1",
          label: "Then",
        },
        {
          id: "Logical_2",
          label: "And",
        },
        {
          id: "Logical_3",
          label: "Or",
        },
        {
          id: "Logical_4",
          label: "Not",
        },
      ],
      type: null,
    },
    {
      id: 7,
      label: "Math",
      description: "Define math expressions",
      hasOptions: false,
      child: [],
      type: null,
    },
  ];
  
export const RULE_FEATURE_TYPE_OPTIONS: RuleOptionType[] = [
  {
    id: 0,
    label: "Sub model",
    hasOptions: false,
    child: [],
    type: null,
  },
  {
    id: 1,
    label: "Field",
    hasOptions: false,
    child: [],
    type: null,
  },
  {
    id: 2,
    label: "Category",
    hasOptions: false,
    child: [],
    type: null,
  },
  {
    id: 3,
    label: CONNECTOR,
    hasOptions: false,
    child: [],
    type: null,
  },
];

export const RULE_OPERATOR_OPTIONS: RuleOptionType[] = [
  {
    id: 0,
    label: "Is defaulted",
    hasOptions: false,
    child: [],
    type: null,
  },
  {
    id: 1,
    label: "Equals",
    hasOptions: false,
    child: [],
    type: null,
  },
  {
    id: 2,
    label: "Required",
    hasOptions: false,
    child: [],
    type: null,
  },
  {
    id: 3,
    label: "Excluded",
    hasOptions: false,
    child: [],
    type: null,
  },
];

//RULE STATIC STRINGS
export const RULE_VALIDATION_MESSAGE: string = "Please enter a valid Rule"
export const RULE_NAME_MANDATORY_MESSAGE: string = "Rule name is mandatory field"
export const RULE_UPDATE_MESSAGE:string = "Rule Updated Succesfully"
export const RULE_SAVE_MESSAGE:string = "Rule Saved Succesfully"
export const RULE_CONDITION:string = "Condition"
export const RULE_DONE:string = "Done"
export const RULE_EXPRESSION:string = "Expression"
export const RULE_RULE:string = "Rule"
export const RULE_SELECT:string = "Select"
export const RULE_OPERATOR:string = "Operator"
export const RULE_NAME:string = "Rule Name"
export const RULE_DESCRIPTION:string = "Description"
export const RULE_FEATURE_TYPE:string = "Feature Type"
export const RULE_FEATURE:string = "Feature"
export const RULE_EMPTY_STRING:string = ""
export const RULE_ADD_FIELD:string = "Add Field"
export const RULE_EDIT:string = "Edit"
export const RULE_STAR:string = "*"
export const RULE_SAVE: string = "Save"

//RULE FUNCTION STRINGS
export const RULE_FUNCTION_EXPRESSION: string = "expression"
export const RULE_FUNCTION_PARENT: string = "parent"
export const RULE_FUNCTION_CHILD: string = "child"
export const RULE_FUNCTION_ADD: string = "add"
export const RULE_FUNCTION_SAVE: string = "save"
export const RULE_FUNCTION_EDIT: string = "edit"
export const RULE_FUNCTION_DELETE: string = "delete"
export const RULE_FUNCTION_RULE_NAME: string = "ruleName"
export const RULE_FUNCTION_CONDITION: string = "condition"
export const RULE_FUNCTION_0: string = "0"
export const RULE_FUNCTION_1: string = "1"
export const RULE_FUNCTION_2: string = "2"
export const RULE_FUNCTION_3: string = "3"
export const RULE_FUNCTION_SUBMODEL: string = "Submodel"
export const RULE_FUNCTION_SUBMODEL_FIELD: string = "SubmodelField"
export const RULE_FUNCTION_SUBMODEL_FIELD_CHOICE: string = "SubmodelFieldChoice"
export const RULE_FUNCTION_FIELD: string = "Field"
export const RULE_FUNCTION_CATEGORY: string = "Category"
export const RULE_FUNCTION_CONNECTOR: string = "Binding"
export const RULE_FUNCTION_DESCRIPTION: string = "description"
export const RULE_FUNCTION_NAME: string = "name"

//FUNCTION CONSTANTS
export const MIN_COUNT: string = "minCount"
export const MAX_COUNT: string = "maxCount"
export const MIN_QUANTITY: string = "minQuantity"
export const MAX_QUANTITY: string = "maxQuantity"


//MULTICHOICE CONFIGURATION CONSTANTS
export const ATTRIBUTE: string = "attribute"
export const LIST: string = "list"
export const CUSTOM: string = "custom"
export const NO_IMAGE_AVAILABLE: string = "No Image Available"
export const ITEM_IMAGE:string = "Item Image"
export const SELECT_CLASS:string = "Select Class"
export const SYNC:string = "Sync"
export const VIEW_ON_LISTS:string = "View on Lists"

//Inclusion Exclusion
export const EXCLUSION_OPTIONS: string[] = ["Hide", "Disable"]
export const EXCLUSION_DEFAULT: string = "Hide"
export const MULTI_CHOICE_EXCLUDED_OPTIONS: string[] = ["Hide", "Disable", "Disable and moved to the bottom of the list"]
export const MULTI_CHOICE_EXCLUDED_DEFAULT: string = "Disable"
export const INCLUSION_OPTIONS: string[] = ["Enable", "Enable and mark as included by a rule"]
export const INCLUSION_DEFAULT: string = "Enable and mark as included by a rule"
export const MULTI_FILTER_VALUES = [
  {display: '<\xa0\xa0\xa0\xa0\xa0>', value: '< >'},
  {display: '<=\xa0\xa0\xa0>=', value: '<= >='},
  {display: '<=\xa0\xa0\xa0>', value: '<= >'},
  {display: '<\xa0\xa0\xa0\xa0\xa0>=', value: '< >='},
]
export const FILTER_VALUES = [
  {display: '=', value: '='},
  {display: '!=', value: '!='},
  {display: '>', value: '>'},
  {display: '>=', value: '>='},
  {display: '<', value: '<'},
  {display: '<=', value: '<='},
]